export default "__VITE_ASSET__DFOMMHwQ__"